module.exports = __webpack_public_path__ + "static/media/country_eu.947889af.webp";